import { jsx as _jsx } from "react/jsx-runtime";
import { Folder, Note, VisibilityOff } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const TherapyNotesEmptyState = ({ onAddNote }) => {
    return (_jsx(EmptyState, { backgroundIcon: Folder, primaryIcon: Note, accentIcon: VisibilityOff, title: "No Internal Notes Yet", description: "These are internal notes for your reference only. They are not visible to clients. Use this space to track your contact attempts, observations, follow-up tasks, etc...", action: onAddNote
            ? { label: "Add Note", onClick: onAddNote }
            : undefined }));
};
